import {
  ImportJobsApi,
  CreateGedcomExportRequest,
  GedcomExportBaselineResponse,
  GedcomExportFormat,
  GedcomExportResponse
} from 'we-tree-api-client/v2';

import { getApiConfiguration } from '@/services/SessionService';
import { ApiResult, withApiSetup } from './apiWrapper';

export type { CreateGedcomExportRequest, GedcomExportBaselineResponse, GedcomExportFormat, GedcomExportResponse };

/**
 * Wrapped GEDCOM export API with standardized error handling.
 */
class WrappedGedcomExportApi {
  /**
   * Latest full-export baseline for the family in the given GEDCOM version
   * (defaults to 5.5.1 on the server; 404 when none exists for that version).
   */
  async getBaseline(familyId: string, format?: GedcomExportFormat): Promise<ApiResult<GedcomExportBaselineResponse>> {
    return withApiSetup(
      (config) => new ImportJobsApi(config),
      getApiConfiguration,
      (api) => api.getGedcomExportBaseline(familyId, format)
    );
  }

  /**
   * Sync full or delta GEDCOM export (owner/admin; free on all tiers).
   */
  async createExport(familyId: string, body: CreateGedcomExportRequest): Promise<ApiResult<GedcomExportResponse>> {
    return withApiSetup(
      (config) => new ImportJobsApi(config),
      getApiConfiguration,
      (api) => api.createGedcomExport(familyId, body)
    );
  }
}

export const gedcomExportApi = new WrappedGedcomExportApi();
